import { RefCallback, MutableRefObject } from 'react';

export function fillRef<T>(
  ref: RefCallback<T> | MutableRefObject<T> | null | undefined,
  node: T,
) {
  if (typeof ref === 'function') {
    ref(node);
  } else if (ref) {
    ref.current = node;
  }
}
